export default {
  select_size: "Select a size",
  required: "required",
  select_up_to: "Select up to {{maxCount}}",
};
